var map = {
	"./css/App.sass": 71531,
	"./css/DguvColors.sass": 96070,
	"./css/General.sass": 10800,
	"./css/ImportBootstrap.scss": 17399,
	"./css/Variables.sass": 41161,
	"./html/di213-026/di213-026_10_.html": 78083,
	"./html/di213-026/di213-026_11_.html": 76134,
	"./html/di213-026/di213-026_12_.html": 66601,
	"./html/di213-026/di213-026_14_.html": 89967,
	"./html/di213-026/di213-026_15_.html": 33042,
	"./html/di213-026/di213-026_16_.html": 28197,
	"./html/di213-026/di213-026_17_.html": 68608,
	"./html/di213-026/di213-026_18_.html": 61403,
	"./html/di213-026/di213-026_19_.html": 94174,
	"./html/di213-026/di213-026_20_.html": 14242,
	"./html/di213-026/di213-026_21_.html": 26111,
	"./html/di213-026/di213-026_22_.html": 64176,
	"./html/di213-026/di213-026_24_.html": 43350,
	"./html/di213-026/di213-026_25_.html": 50771,
	"./html/di213-026/di213-026_26_.html": 10116,
	"./html/di213-026/di213-026_27_.html": 56281,
	"./html/di213-026/di213-026_29_.html": 64823,
	"./html/di213-026/di213-026_2_.html": 76422,
	"./html/di213-026/di213-026_30_.html": 39873,
	"./html/di213-026/di213-026_31_.html": 11468,
	"./html/di213-026/di213-026_33_.html": 56286,
	"./html/di213-026/di213-026_34_.html": 48061,
	"./html/di213-026/di213-026_35_.html": 57368,
	"./html/di213-026/di213-026_36_.html": 84039,
	"./html/di213-026/di213-026_37_.html": 79914,
	"./html/di213-026/di213-026_39_.html": 51956,
	"./html/di213-026/di213-026_3_.html": 96483,
	"./html/di213-026/di213-026_40_.html": 38568,
	"./html/di213-026/di213-026_45_.html": 77137,
	"./html/di213-026/di213-026_46_.html": 66158,
	"./html/di213-026/di213-026_50_.html": 24583,
	"./html/di213-026/di213-026_58_.html": 52079,
	"./html/di213-026/di213-026_59_.html": 48178,
	"./html/di213-026/di213-026_5_.html": 197,
	"./html/di213-026/di213-026_60_.html": 58310,
	"./html/di213-026/di213-026_61_.html": 28515,
	"./html/di213-026/di213-026_65_.html": 45263,
	"./html/di213-026/di213-026_6_.html": 27762,
	"./html/di213-026/di213-026_70_.html": 8277,
	"./html/di213-026/di213-026_71_.html": 12752,
	"./html/di213-026/di213-026_72_.html": 9919,
	"./html/di213-026/di213-026_73_.html": 46466,
	"./html/di213-026/di213-026_74_.html": 66969,
	"./html/di213-026/di213-026_7_.html": 50927,
	"./html/di213-026/di213-026_8_.html": 8556,
	"./html/di213-026/di213-026_9_.html": 36961,
	"./html/di213-026/figures/cover.jpg": 37468,
	"./html/di213-026/figures/g1.jpg": 74325,
	"./html/di213-026/figures/g10.jpg": 98137,
	"./html/di213-026/figures/g11.jpg": 77084,
	"./html/di213-026/figures/g12.jpg": 69067,
	"./html/di213-026/figures/g13.jpg": 91022,
	"./html/di213-026/figures/g14.jpg": 53493,
	"./html/di213-026/figures/g15.jpg": 45624,
	"./html/di213-026/figures/g16.jpg": 83079,
	"./html/di213-026/figures/g17.jpg": 27242,
	"./html/di213-026/figures/g18.jpg": 98353,
	"./html/di213-026/figures/g19.jpg": 84020,
	"./html/di213-026/figures/g2.jpg": 64426,
	"./html/di213-026/figures/g20.jpg": 47112,
	"./html/di213-026/figures/g21.jpg": 9477,
	"./html/di213-026/figures/g22.jpg": 86874,
	"./html/di213-026/figures/g23.jpg": 81335,
	"./html/di213-026/figures/g24.jpg": 26988,
	"./html/di213-026/figures/g24a.jpg": 9387,
	"./html/di213-026/figures/g25.jpg": 72361,
	"./html/di213-026/figures/g26.jpg": 98654,
	"./html/di213-026/figures/g27.jpg": 69787,
	"./html/di213-026/figures/g28.jpg": 64320,
	"./html/di213-026/figures/g29.jpg": 3549,
	"./html/di213-026/figures/g3.jpg": 20263,
	"./html/di213-026/figures/g30.jpg": 81159,
	"./html/di213-026/figures/g31.jpg": 85354,
	"./html/di213-026/figures/g32.jpg": 9493,
	"./html/di213-026/figures/g33.jpg": 64664,
	"./html/di213-026/figures/g34.jpg": 51915,
	"./html/di213-026/figures/g35.jpg": 72430,
	"./html/di213-026/figures/g36.jpg": 71097,
	"./html/di213-026/figures/g37.jpg": 26748,
	"./html/di213-026/figures/g38.jpg": 54495,
	"./html/di213-026/figures/g39.jpg": 58178,
	"./html/di213-026/figures/g4.jpg": 14268,
	"./html/di213-026/figures/g40.jpg": 62766,
	"./html/di213-026/figures/g41.jpg": 42251,
	"./html/di213-026/figures/g42.jpg": 17084,
	"./html/di213-026/figures/g43.jpg": 61433,
	"./html/di213-026/figures/g43a.jpg": 71064,
	"./html/di213-026/figures/g44.jpg": 75690,
	"./html/di213-026/figures/g45.jpg": 71495,
	"./html/di213-026/figures/g46.jpg": 55000,
	"./html/di213-026/figures/g47.jpg": 99829,
	"./html/di213-026/figures/g48.jpg": 79974,
	"./html/di213-026/figures/g49.jpg": 18499,
	"./html/di213-026/figures/g5.gif": 39886,
	"./html/di213-026/figures/g50.jpg": 32517,
	"./html/di213-026/figures/g51.jpg": 4904,
	"./html/di213-026/figures/g52.jpg": 27223,
	"./html/di213-026/figures/g53.jpg": 75290,
	"./html/di213-026/figures/g54.jpg": 81129,
	"./html/di213-026/figures/g55.jpg": 66988,
	"./html/di213-026/figures/g56.jpg": 9787,
	"./html/di213-026/figures/g57.jpg": 89630,
	"./html/di213-026/figures/g58.jpg": 36221,
	"./html/di213-026/figures/g59.jpg": 84480,
	"./html/di213-026/figures/g6.jpg": 28206,
	"./html/di213-026/figures/g60.jpg": 30324,
	"./html/di213-026/figures/g61.jpg": 2129,
	"./html/di213-026/figures/g62.jpg": 86278,
	"./html/di213-026/figures/g63.jpg": 76387,
	"./html/di213-026/figures/g64.jpg": 41232,
	"./html/di213-026/figures/g65.jpg": 86125,
	"./html/di213-026/figures/g66.jpg": 16898,
	"./html/di213-026/figures/g67.jpg": 24959,
	"./html/di213-026/figures/g68.jpg": 80860,
	"./html/di213-026/figures/g69.jpg": 67737,
	"./html/di213-026/figures/g7.jpg": 6251,
	"./html/di213-026/figures/g70.jpg": 74227,
	"./html/di213-026/figures/g71.jpg": 87766,
	"./html/di213-026/figures/g72.jpg": 58113,
	"./html/di213-026/figures/g8.jpg": 74640,
	"./html/di213-026/figures/g9.jpg": 26861,
	"./html/di213-026/figures/gs1.gif": 31789,
	"./html/di213-026/figures/gs1.png": 71790,
	"./html/di213-026/figures/gs2.gif": 11250,
	"./html/di213-026/figures/gs2.png": 43589,
	"./html/di213-026/figures/gs2.svg": 56369,
	"./html/di213-026/figures/gtab1.jpg": 76576,
	"./html/di213-026/figures/gtab2.jpg": 73839,
	"./html/di213-026/figures/komm_mit_blau.gif": 53916,
	"./html/di213-026/merkblt_uvv-2-0-0.css": 92638,
	"./html/di213-026e/di213-026e_10_.html": 64743,
	"./html/di213-026e/di213-026e_11_.html": 76842,
	"./html/di213-026e/di213-026e_12_.html": 78749,
	"./html/di213-026e/di213-026e_14_.html": 76059,
	"./html/di213-026e/di213-026e_15_.html": 10686,
	"./html/di213-026e/di213-026e_16_.html": 94273,
	"./html/di213-026e/di213-026e_17_.html": 22796,
	"./html/di213-026e/di213-026e_18_.html": 54319,
	"./html/di213-026e/di213-026e_19_.html": 49458,
	"./html/di213-026e/di213-026e_20_.html": 35814,
	"./html/di213-026e/di213-026e_21_.html": 54115,
	"./html/di213-026e/di213-026e_22_.html": 96020,
	"./html/di213-026e/di213-026e_24_.html": 92722,
	"./html/di213-026e/di213-026e_25_.html": 49647,
	"./html/di213-026e/di213-026e_26_.html": 28288,
	"./html/di213-026e/di213-026e_27_.html": 4229,
	"./html/di213-026e/di213-026e_29_.html": 37435,
	"./html/di213-026e/di213-026e_2_.html": 83730,
	"./html/di213-026e/di213-026e_30_.html": 14261,
	"./html/di213-026e/di213-026e_31_.html": 40208,
	"./html/di213-026e/di213-026e_33_.html": 90274,
	"./html/di213-026e/di213-026e_34_.html": 15961,
	"./html/di213-026e/di213-026e_35_.html": 69796,
	"./html/di213-026e/di213-026e_36_.html": 26803,
	"./html/di213-026e/di213-026e_37_.html": 3030,
	"./html/di213-026e/di213-026e_39_.html": 8923,
	"./html/di213-026e/di213-026e_3_.html": 71279,
	"./html/di213-026e/di213-026e_40_.html": 1860,
	"./html/di213-026e/di213-026e_45_.html": 46325,
	"./html/di213-026e/di213-026e_46_.html": 5986,
	"./html/di213-026e/di213-026e_50_.html": 7491,
	"./html/di213-026e/di213-026e_58_.html": 67867,
	"./html/di213-026e/di213-026e_59_.html": 64382,
	"./html/di213-026e/di213-026e_5_.html": 24745,
	"./html/di213-026e/di213-026e_60_.html": 16706,
	"./html/di213-026e/di213-026e_61_.html": 30015,
	"./html/di213-026e/di213-026e_65_.html": 85427,
	"./html/di213-026e/di213-026e_6_.html": 84294,
	"./html/di213-026e/di213-026e_70_.html": 1249,
	"./html/di213-026e/di213-026e_71_.html": 42252,
	"./html/di213-026e/di213-026e_72_.html": 76283,
	"./html/di213-026e/di213-026e_73_.html": 62974,
	"./html/di213-026e/di213-026e_74_.html": 47261,
	"./html/di213-026e/di213-026e_7_.html": 48547,
	"./html/di213-026e/di213-026e_8_.html": 16376,
	"./html/di213-026e/di213-026e_9_.html": 74717,
	"./html/di213-026e/figures/cover.jpg": 21435,
	"./html/di213-026e/figures/g1.jpg": 11256,
	"./html/di213-026e/figures/g10.jpg": 4642,
	"./html/di213-026e/figures/g11.jpg": 24639,
	"./html/di213-026e/figures/g12.jpg": 9680,
	"./html/di213-026e/figures/g13.jpg": 53133,
	"./html/di213-026e/figures/g14.jpg": 59782,
	"./html/di213-026e/figures/g15.jpg": 24483,
	"./html/di213-026e/figures/g16.jpg": 39028,
	"./html/di213-026e/figures/g17.jpg": 17553,
	"./html/di213-026e/figures/g18.jpg": 81674,
	"./html/di213-026e/figures/g19.jpg": 20679,
	"./html/di213-026e/figures/g2.jpg": 65063,
	"./html/di213-026e/figures/g20.jpg": 47527,
	"./html/di213-026e/figures/g21.jpg": 35370,
	"./html/di213-026e/figures/g22.jpg": 75861,
	"./html/di213-026e/figures/g23.jpg": 14680,
	"./html/di213-026e/figures/g24.jpg": 18283,
	"./html/di213-026e/figures/g24a.jpg": 93094,
	"./html/di213-026e/figures/g25.jpg": 22446,
	"./html/di213-026e/figures/g26.jpg": 37465,
	"./html/di213-026e/figures/g27.jpg": 93116,
	"./html/di213-026e/figures/g28.jpg": 20863,
	"./html/di213-026e/figures/g29.jpg": 8194,
	"./html/di213-026e/figures/g3.jpg": 92874,
	"./html/di213-026e/figures/g30.jpg": 97128,
	"./html/di213-026e/figures/g31.jpg": 59493,
	"./html/di213-026e/figures/g32.jpg": 36890,
	"./html/di213-026e/figures/g33.jpg": 47703,
	"./html/di213-026e/figures/g34.jpg": 93356,
	"./html/di213-026e/figures/g35.jpg": 38729,
	"./html/di213-026e/figures/g36.jpg": 65022,
	"./html/di213-026e/figures/g37.jpg": 19803,
	"./html/di213-026e/figures/g38.jpg": 30688,
	"./html/di213-026e/figures/g39.jpg": 69917,
	"./html/di213-026e/figures/g4.jpg": 63769,
	"./html/di213-026e/figures/g40.jpg": 98885,
	"./html/di213-026e/figures/g41.jpg": 54920,
	"./html/di213-026e/figures/g42.jpg": 93591,
	"./html/di213-026e/figures/g43-1.jpg": 26688,
	"./html/di213-026e/figures/g43.jpg": 41658,
	"./html/di213-026e/figures/g43a.jpg": 74661,
	"./html/di213-026e/figures/g44.jpg": 31145,
	"./html/di213-026e/figures/g45.jpg": 33356,
	"./html/di213-026e/figures/g46.jpg": 59803,
	"./html/di213-026e/figures/g47.jpg": 39646,
	"./html/di213-026e/figures/g48.jpg": 2589,
	"./html/di213-026e/figures/g49.jpg": 34496,
	"./html/di213-026e/figures/g5.gif": 82599,
	"./html/di213-026e/figures/g50.jpg": 12782,
	"./html/di213-026e/figures/g51.jpg": 8619,
	"./html/di213-026e/figures/g52.jpg": 83452,
	"./html/di213-026e/figures/g53.jpg": 27801,
	"./html/di213-026e/figures/g54.jpg": 25706,
	"./html/di213-026e/figures/g55.jpg": 37863,
	"./html/di213-026e/figures/g56.jpg": 5016,
	"./html/di213-026e/figures/g57.jpg": 66197,
	"./html/di213-026e/figures/g58.jpg": 46342,
	"./html/di213-026e/figures/g59.jpg": 68515,
	"./html/di213-026e/figures/g6.jpg": 34699,
	"./html/di213-026e/figures/g60.jpg": 24243,
	"./html/di213-026e/figures/g61.jpg": 54134,
	"./html/di213-026e/figures/g62.jpg": 24481,
	"./html/di213-026e/figures/g63.jpg": 46436,
	"./html/di213-026e/figures/g64.jpg": 71375,
	"./html/di213-026e/figures/g65.jpg": 98994,
	"./html/di213-026e/figures/g66.jpg": 8893,
	"./html/di213-026e/figures/g67.jpg": 57760,
	"./html/di213-026e/figures/g68.jpg": 66107,
	"./html/di213-026e/figures/g69.jpg": 34622,
	"./html/di213-026e/figures/g7.jpg": 56654,
	"./html/di213-026e/figures/g70.jpg": 96692,
	"./html/di213-026e/figures/g71.jpg": 68497,
	"./html/di213-026e/figures/g72.jpg": 36294,
	"./html/di213-026e/figures/g8.jpg": 71661,
	"./html/di213-026e/figures/g9.jpg": 3088,
	"./html/di213-026e/figures/gs1.gif": 9762,
	"./html/di213-026e/figures/gs2.gif": 87613,
	"./html/di213-026e/figures/gs2.svg": 65636,
	"./html/di213-026e/figures/komm_mit_blau.gif": 71463,
	"./html/di213-026e/figures/tb1g1.gif": 30550,
	"./html/di213-026e/figures/tb1g10.gif": 90778,
	"./html/di213-026e/figures/tb1g11.gif": 56099,
	"./html/di213-026e/figures/tb1g12.gif": 6588,
	"./html/di213-026e/figures/tb1g13.gif": 44821,
	"./html/di213-026e/figures/tb1g14.gif": 83318,
	"./html/di213-026e/figures/tb1g15.gif": 20751,
	"./html/di213-026e/figures/tb1g16.gif": 31304,
	"./html/di213-026e/figures/tb1g17.gif": 74113,
	"./html/di213-026e/figures/tb1g18.gif": 5090,
	"./html/di213-026e/figures/tb1g19.gif": 52811,
	"./html/di213-026e/figures/tb1g2.gif": 21345,
	"./html/di213-026e/figures/tb1g3.gif": 78536,
	"./html/di213-026e/figures/tb1g4.gif": 19683,
	"./html/di213-026e/figures/tb1g5.gif": 54362,
	"./html/di213-026e/figures/tb1g6.gif": 8405,
	"./html/di213-026e/figures/tb1g7.gif": 53820,
	"./html/di213-026e/figures/tb1g8.gif": 30807,
	"./html/di213-026e/figures/tb1g9.gif": 87998,
	"./html/di213-026e/figures/tb2g1.gif": 44341,
	"./html/di213-026e/figures/tb2g2.gif": 64890,
	"./html/di213-026e/figures/tb2g3.gif": 64963,
	"./html/di213-026e/figures/tb2g4.gif": 70792,
	"./html/di213-026e/figures/tb2g5.gif": 48225,
	"./html/di213-026e/figures/tb2g6.gif": 58038,
	"./html/di213-026e/figures/tb2g7.gif": 60239,
	"./html/di213-026e/figures/tb2g8.gif": 36484,
	"./html/di213-026e/merkblt_uvv-2-0-0.css": 35623,
	"./html/jv/BOOK.gif": 62123,
	"./html/jv/DOC.gif": 52470,
	"./html/jv/PDF.gif": 10806,
	"./html/jv/PPT.gif": 96996,
	"./html/jv/RTF.gif": 76320,
	"./html/jv/XLS.gif": 86963,
	"./html/jv/ZIP.gif": 67589,
	"./html/jv/aend_delete.gif": 89882,
	"./html/jv/aend_delete_end.gif": 12788,
	"./html/jv/aend_edit.gif": 45743,
	"./html/jv/aend_edit_end.gif": 97309,
	"./html/jv/aend_end.gif": 28490,
	"./html/jv/aend_home.gif": 20406,
	"./html/jv/aend_new.gif": 21047,
	"./html/jv/aend_new_end.gif": 66661,
	"./html/jv/aend_next.gif": 79544,
	"./html/jv/aend_prev.gif": 5272,
	"./html/jv/aend_start.gif": 41829,
	"./html/jv/b_next.gif": 19170,
	"./html/jv/b_next_ba.gif": 65722,
	"./html/jv/b_prev.gif": 96206,
	"./html/jv/b_prev_ba.gif": 19798,
	"./html/jv/bmf.gif": 37971,
	"./html/jv/d_next.gif": 49188,
	"./html/jv/d_next_ba.gif": 99624,
	"./html/jv/d_prev.gif": 12668,
	"./html/jv/d_prev_ba.gif": 68064,
	"./html/jv/dguv.gif": 66174,
	"./html/jv/dwg.gif": 3298,
	"./html/jv/fachinfo.gif": 68378,
	"./html/jv/geaendrt.gif": 47878,
	"./html/jv/gliederung.gif": 18480,
	"./html/jv/home.gif": 14749,
	"./html/jv/jv_grund.gif": 63399,
	"./html/jv/jv_grundbuk.gif": 21107,
	"./html/jv/jv_info.gif": 4315,
	"./html/jv/jv_infobuk.gif": 41815,
	"./html/jv/jv_recht.gif": 13131,
	"./html/jv/jv_regel.gif": 32156,
	"./html/jv/jv_regelbuk.gif": 21178,
	"./html/jv/jv_revision.gif": 5992,
	"./html/jv/jv_sonst.gif": 82196,
	"./html/jv/jv_tr.gif": 6273,
	"./html/jv/jv_uvv.gif": 33212,
	"./html/jv/jv_uvvbuk.gif": 54874,
	"./html/jv/jv_zh1.gif": 90410,
	"./html/jv/link.gif": 91944,
	"./html/jv/merkblt_uvv-2-0-0.css": 97764,
	"./html/jv/mp3.gif": 36018,
	"./html/jv/oncd.gif": 60486,
	"./html/jv/themenfeld_audiovisuell.gif": 12693,
	"./html/jv/themenfeld_bestpractice.gif": 48254,
	"./html/jv/themenfeld_fachartikel.gif": 79991,
	"./html/jv/themenfeld_fahrsicherheit.gif": 82388,
	"./html/jv/themenfeld_fragen.gif": 98666,
	"./html/jv/themenfeld_hilfegefbu.gif": 46846,
	"./html/jv/themenfeld_info.gif": 27411,
	"./html/jv/themenfeld_lernmodul.gif": 11605,
	"./html/jv/themenfeld_links.gif": 26022,
	"./html/jv/themenfeld_muster.gif": 62205,
	"./html/jv/themenfeld_recht.gif": 77779,
	"./html/jv/themenfeld_sem.gif": 40824,
	"./html/jv/themenwelt_audiovisuell.gif": 93580,
	"./html/jv/themenwelt_audiovisuell.svg": 98581,
	"./html/jv/themenwelt_fachartikel.gif": 29692,
	"./html/jv/themenwelt_fachartikel.svg": 91651,
	"./html/jv/themenwelt_hilfegefbu.gif": 16191,
	"./html/jv/themenwelt_hilfegefbu.svg": 50818,
	"./html/jv/themenwelt_info.gif": 37414,
	"./html/jv/themenwelt_info.svg": 25311,
	"./html/jv/themenwelt_links.gif": 47765,
	"./html/jv/themenwelt_links.svg": 82858,
	"./html/jv/themenwelt_muster.gif": 14840,
	"./html/jv/themenwelt_muster.svg": 23789,
	"./html/jv/themenwelt_recht.gif": 45908,
	"./html/jv/themenwelt_recht.svg": 42175,
	"./html/jv/themenwelt_sem.gif": 30351,
	"./html/jv/themenwelt_sem.svg": 15352,
	"./html/jv/toc-2.0.0.css": 75341,
	"./html/jv/vbg_mini.png": 89144,
	"./html/jv/vbg_mini2.png": 46456,
	"./html/jv/vortrag.gif": 98635,
	"./html/jv/web.gif": 56750,
	"./html/jv/x_total.gif": 65427,
	"./html/jv/zurueckgezogen.gif": 80852,
	"./images/bgrci-logo.svg": 60572,
	"./images/bottom-slider.svg": 33604,
	"./images/cartoons/de/chapter-2.1.svg": 40008,
	"./images/cartoons/de/chapter-2.2_single_1.svg": 27710,
	"./images/cartoons/de/chapter-2.2_single_2.svg": 81885,
	"./images/cartoons/de/chapter-2.2_single_3.svg": 11260,
	"./images/cartoons/de/chapter-2.3_single_1.svg": 69013,
	"./images/cartoons/de/chapter-2.3_single_2.svg": 27766,
	"./images/cartoons/de/chapter-2.3_single_3.svg": 14887,
	"./images/cartoons/de/chapter-2.4_single_1.svg": 11248,
	"./images/cartoons/de/chapter-2.4_single_2.svg": 77347,
	"./images/cartoons/de/chapter-2.4_single_3.svg": 27954,
	"./images/cartoons/de/chapter-2.5_single_1.svg": 19447,
	"./images/cartoons/de/chapter-2.5_single_2.svg": 76324,
	"./images/cartoons/de/chapter-2.6_single_1.svg": 89090,
	"./images/cartoons/de/chapter-2.6_single_2.svg": 46193,
	"./images/cartoons/de/chapter-2.6_single_3.svg": 31808,
	"./images/cartoons/de/chapter-2.7_single_1.svg": 39209,
	"./images/cartoons/de/chapter-2.7_single_2.svg": 97274,
	"./images/cartoons/de/chapter-2.8_single_1.svg": 77348,
	"./images/cartoons/de/chapter-2.8_single_2.svg": 81943,
	"./images/cartoons/de/chapter-2.8_single_3.svg": 35494,
	"./images/cartoons/de/chapter-3.1_single_1.svg": 88592,
	"./images/cartoons/de/chapter-3.1_single_2.svg": 45635,
	"./images/cartoons/de/chapter-3.2_single_1.svg": 14761,
	"./images/cartoons/de/chapter-3.2_single_2.svg": 30298,
	"./images/cartoons/de/chapter-3.2_single_3.svg": 44907,
	"./images/cartoons/de/chapter-3.3_single_1.svg": 91522,
	"./images/cartoons/de/chapter-3.3_single_2.svg": 46065,
	"./images/cartoons/de/chapter-3.3_single_3.svg": 83264,
	"./images/cartoons/de/chapter-3.4.svg": 99144,
	"./images/cartoons/de/chapter-3.5_single_1.svg": 11164,
	"./images/cartoons/de/chapter-3.5_single_2.svg": 13487,
	"./images/cartoons/de/chapter-3.6_single_1.svg": 2869,
	"./images/cartoons/de/chapter-3.6_single_2.svg": 89910,
	"./images/cartoons/de/chapter-3.6_single_3.svg": 29447,
	"./images/cartoons/de/chapter-3.7_single_1.svg": 78366,
	"./images/cartoons/de/chapter-3.7_single_2.svg": 6813,
	"./images/cartoons/de/chapter-3.8_single_1.svg": 92927,
	"./images/cartoons/de/chapter-3.8_single_2.svg": 37580,
	"./images/cartoons/de/chapter-3.9_single_1.svg": 19576,
	"./images/cartoons/de/chapter-3.9_single_2.svg": 58411,
	"./images/cartoons/de/chapter-4.1_single_1.svg": 75385,
	"./images/cartoons/de/chapter-4.1_single_2.svg": 26090,
	"./images/cartoons/de/chapter-4.1_single_3.svg": 94907,
	"./images/cartoons/de/chapter-4.2_single_1.svg": 42432,
	"./images/cartoons/de/chapter-4.2_single_2.svg": 63187,
	"./images/cartoons/de/chapter-4.3_single_1.svg": 32199,
	"./images/cartoons/de/chapter-4.3_single_2.svg": 60692,
	"./images/cartoons/de/chapter-4.3_single_3.svg": 86325,
	"./images/cartoons/de/chapter-4.4_single_1.svg": 66670,
	"./images/cartoons/de/chapter-4.4_single_2.svg": 77389,
	"./images/cartoons/de/chapter-4.4_single_3.svg": 41932,
	"./images/cartoons/de/chapter-4.4_single_4.svg": 82323,
	"./images/cartoons/de/chapter-4.5_single_1.svg": 9061,
	"./images/cartoons/de/chapter-4.5_single_2.svg": 77286,
	"./images/cartoons/de/chapter-4.5_single_3.svg": 66263,
	"./images/cartoons/de/chapter-4.6.svg": 39145,
	"./images/cartoons/de/chapter-4.7_single_1.svg": 41219,
	"./images/cartoons/de/chapter-4.7_single_2.svg": 75120,
	"./images/cartoons/de/chapter-5.1_single_1.svg": 46310,
	"./images/cartoons/de/chapter-5.1_single_2.svg": 66181,
	"./images/cartoons/de/chapter-5.2_single_1.svg": 58043,
	"./images/cartoons/de/chapter-5.2_single_2.svg": 76680,
	"./images/cartoons/de/chapter-5.3_single_1.svg": 18692,
	"./images/cartoons/de/chapter-5.3_single_2.svg": 73143,
	"./images/cartoons/de/chapter-5.4_single_1.svg": 52145,
	"./images/cartoons/de/chapter-5.4_single_2.svg": 11394,
	"./images/cartoons/de/chapter-5.4_single_3.svg": 98771,
	"./images/cartoons/de/chapter-5.5_single_1.svg": 69706,
	"./images/cartoons/de/chapter-5.5_single_2.svg": 30457,
	"./images/cartoons/de/chapter-5.5_single_3.svg": 22536,
	"./images/cartoons/de/chapter-6.1_single_1.svg": 84919,
	"./images/cartoons/de/chapter-6.1_single_2.svg": 30468,
	"./images/cartoons/de/chapter-6.2_single_1.svg": 65218,
	"./images/cartoons/de/chapter-6.2_single_2.svg": 85585,
	"./images/cartoons/de/chapter-6.3_single_1.svg": 96201,
	"./images/cartoons/de/chapter-6.3_single_2.svg": 81114,
	"./images/cartoons/de/chapter-6.4_single_1.svg": 27932,
	"./images/cartoons/de/chapter-6.4_single_2.svg": 6959,
	"./images/cartoons/de/chapter-6.5_single_1.svg": 32755,
	"./images/cartoons/de/chapter-6.5_single_2.svg": 12000,
	"./images/cartoons/de/chapter-6.5_single_3.svg": 47953,
	"./images/cartoons/de/chapter-6.6_single_1.svg": 55134,
	"./images/cartoons/de/chapter-6.6_single_2.svg": 17757,
	"./images/cartoons/de/chapter-6.6_single_3.svg": 89212,
	"./images/cartoons/en/chapter-2.1.svg": 14052,
	"./images/cartoons/en/chapter-2.2_single_1.svg": 59954,
	"./images/cartoons/en/chapter-2.2_single_2.svg": 53089,
	"./images/cartoons/en/chapter-2.2_single_3.svg": 17552,
	"./images/cartoons/en/chapter-2.3_single_1.svg": 6201,
	"./images/cartoons/en/chapter-2.3_single_2.svg": 45450,
	"./images/cartoons/en/chapter-2.3_single_3.svg": 63291,
	"./images/cartoons/en/chapter-2.4_single_1.svg": 92844,
	"./images/cartoons/en/chapter-2.4_single_2.svg": 71871,
	"./images/cartoons/en/chapter-2.4_single_3.svg": 43438,
	"./images/cartoons/en/chapter-2.5_single_1.svg": 98147,
	"./images/cartoons/en/chapter-2.5_single_1_alt.svg": 97787,
	"./images/cartoons/en/chapter-2.5_single_2.svg": 41104,
	"./images/cartoons/en/chapter-2.5_single_2_alt.svg": 45780,
	"./images/cartoons/en/chapter-2.6_single_1.svg": 34350,
	"./images/cartoons/en/chapter-2.6_single_2.svg": 82701,
	"./images/cartoons/en/chapter-2.6_single_3.svg": 83756,
	"./images/cartoons/en/chapter-2.7_single_1.svg": 84837,
	"./images/cartoons/en/chapter-2.7_single_2.svg": 85702,
	"./images/cartoons/en/chapter-2.8_single_1.svg": 97096,
	"./images/cartoons/en/chapter-2.8_single_2.svg": 28987,
	"./images/cartoons/en/chapter-2.8_single_3.svg": 60170,
	"./images/cartoons/en/chapter-3.1_single_1.svg": 19652,
	"./images/cartoons/en/chapter-3.1_single_2.svg": 74103,
	"./images/cartoons/en/chapter-3.2_single_1.svg": 79581,
	"./images/cartoons/en/chapter-3.2_single_2.svg": 16958,
	"./images/cartoons/en/chapter-3.2_single_3.svg": 53359,
	"./images/cartoons/en/chapter-3.3_single_1.svg": 30918,
	"./images/cartoons/en/chapter-3.3_single_2.svg": 67141,
	"./images/cartoons/en/chapter-3.3_single_3.svg": 89124,
	"./images/cartoons/en/chapter-3.4.svg": 87900,
	"./images/cartoons/en/chapter-3.5_single_1.svg": 3128,
	"./images/cartoons/en/chapter-3.5_single_2.svg": 37515,
	"./images/cartoons/en/chapter-3.6_single_1.svg": 53105,
	"./images/cartoons/en/chapter-3.6_single_2.svg": 96002,
	"./images/cartoons/en/chapter-3.6_single_3.svg": 99731,
	"./images/cartoons/en/chapter-3.7_single_1.svg": 70666,
	"./images/cartoons/en/chapter-3.7_single_2.svg": 31417,
	"./images/cartoons/en/chapter-3.8_single_1.svg": 53203,
	"./images/cartoons/en/chapter-3.8_single_2.svg": 62464,
	"./images/cartoons/en/chapter-3.9_single_1.svg": 17948,
	"./images/cartoons/en/chapter-3.9_single_2.svg": 96975,
	"./images/cartoons/en/chapter-4.1_single_1.svg": 94741,
	"./images/cartoons/en/chapter-4.1_single_2.svg": 58102,
	"./images/cartoons/en/chapter-4.1_single_3.svg": 21319,
	"./images/cartoons/en/chapter-4.2_single_1.svg": 28892,
	"./images/cartoons/en/chapter-4.2_single_2.svg": 7919,
	"./images/cartoons/en/chapter-4.3_single_1.svg": 17363,
	"./images/cartoons/en/chapter-4.3_single_2.svg": 96608,
	"./images/cartoons/en/chapter-4.3_single_3.svg": 32561,
	"./images/cartoons/en/chapter-4.4_single_1.svg": 66178,
	"./images/cartoons/en/chapter-4.4_single_2.svg": 86545,
	"./images/cartoons/en/chapter-4.4_single_3.svg": 50592,
	"./images/cartoons/en/chapter-4.4_single_4.svg": 16479,
	"./images/cartoons/en/chapter-4.5_single_1.svg": 97161,
	"./images/cartoons/en/chapter-4.5_single_2.svg": 82074,
	"./images/cartoons/en/chapter-4.5_single_3.svg": 1131,
	"./images/cartoons/en/chapter-4.6_single_1.svg": 2448,
	"./images/cartoons/en/chapter-4.7_single_1.svg": 85879,
	"./images/cartoons/en/chapter-4.7_single_2.svg": 31428,
	"./images/cartoons/en/chapter-5.1_single_1.svg": 1762,
	"./images/cartoons/en/chapter-5.1_single_2.svg": 82161,
	"./images/cartoons/en/chapter-5.2_single_1.svg": 36247,
	"./images/cartoons/en/chapter-5.2_single_2.svg": 93124,
	"./images/cartoons/en/chapter-5.3_single_1.svg": 94384,
	"./images/cartoons/en/chapter-5.3_single_2.svg": 131,
	"./images/cartoons/en/chapter-5.4_single_1.svg": 35637,
	"./images/cartoons/en/chapter-5.4_single_2.svg": 47414,
	"./images/cartoons/en/chapter-5.4_single_3.svg": 11239,
	"./images/cartoons/en/chapter-5.5_single_1.svg": 69822,
	"./images/cartoons/en/chapter-5.5_single_2.svg": 23997,
	"./images/cartoons/en/chapter-5.5_single_3.svg": 34524,
	"./images/cartoons/en/chapter-6.1_single_1.svg": 73603,
	"./images/cartoons/en/chapter-6.1_single_2.svg": 84208,
	"./images/cartoons/en/chapter-6.2_single_1.svg": 36046,
	"./images/cartoons/en/chapter-6.2_single_2.svg": 19021,
	"./images/cartoons/en/chapter-6.3_single_1.svg": 85029,
	"./images/cartoons/en/chapter-6.3_single_2.svg": 48806,
	"./images/cartoons/en/chapter-6.4_single_1.svg": 16576,
	"./images/cartoons/en/chapter-6.4_single_2.svg": 87475,
	"./images/cartoons/en/chapter-6.5_single_1.svg": 28647,
	"./images/cartoons/en/chapter-6.5_single_2.svg": 80436,
	"./images/cartoons/en/chapter-6.5_single_3.svg": 36693,
	"./images/cartoons/en/chapter-6.6_single_1.svg": 5522,
	"./images/cartoons/en/chapter-6.6_single_2.svg": 10561,
	"./images/cartoons/en/chapter-6.6_single_3.svg": 19440,
	"./images/cartoons/thumbs/chapter-2.1_thumb.svg": 279,
	"./images/cartoons/thumbs/chapter-2.2_thumb.svg": 48736,
	"./images/cartoons/thumbs/chapter-2.3_thumb.svg": 53781,
	"./images/cartoons/thumbs/chapter-2.4_thumb.svg": 32382,
	"./images/cartoons/thumbs/chapter-2.5_thumb.svg": 4971,
	"./images/cartoons/thumbs/chapter-2.6_thumb.svg": 89796,
	"./images/cartoons/thumbs/chapter-2.7_thumb.svg": 85577,
	"./images/cartoons/thumbs/chapter-2.8_thumb.svg": 52258,
	"./images/cartoons/thumbs/chapter-3.1_thumb.svg": 65222,
	"./images/cartoons/thumbs/chapter-3.2_thumb.svg": 72081,
	"./images/cartoons/thumbs/chapter-3.3_thumb.svg": 36012,
	"./images/cartoons/thumbs/chapter-3.4_thumb.svg": 72831,
	"./images/cartoons/thumbs/chapter-3.5_thumb.svg": 63874,
	"./images/cartoons/thumbs/chapter-3.6_thumb.svg": 3517,
	"./images/cartoons/thumbs/chapter-3.7_thumb.svg": 96296,
	"./images/cartoons/thumbs/chapter-3.8_thumb.svg": 95627,
	"./images/cartoons/thumbs/chapter-3.9_thumb.svg": 52158,
	"./images/cartoons/thumbs/chapter-4.1_thumb.svg": 63257,
	"./images/cartoons/thumbs/chapter-4.2_thumb.svg": 750,
	"./images/cartoons/thumbs/chapter-4.3_thumb.svg": 5627,
	"./images/cartoons/thumbs/chapter-4.4_thumb.svg": 96208,
	"./images/cartoons/thumbs/chapter-4.5_thumb.svg": 10885,
	"./images/cartoons/thumbs/chapter-4.6_thumb.svg": 79818,
	"./images/cartoons/thumbs/chapter-4.7_thumb.svg": 21479,
	"./images/cartoons/thumbs/chapter-5.1_thumb.svg": 68976,
	"./images/cartoons/thumbs/chapter-5.2_thumb.svg": 88679,
	"./images/cartoons/thumbs/chapter-5.3_thumb.svg": 98058,
	"./images/cartoons/thumbs/chapter-5.4_thumb.svg": 55065,
	"./images/cartoons/thumbs/chapter-5.5_thumb.svg": 74132,
	"./images/cartoons/thumbs/chapter-6.1_thumb.svg": 58571,
	"./images/cartoons/thumbs/chapter-6.2_thumb.svg": 44996,
	"./images/cartoons/thumbs/chapter-6.3_thumb.svg": 68201,
	"./images/cartoons/thumbs/chapter-6.4_thumb.svg": 23002,
	"./images/cartoons/thumbs/chapter-6.5_thumb.svg": 37463,
	"./images/cartoons/thumbs/chapter-6.6_thumb.svg": 19456,
	"./images/characters/charly.png": 94843,
	"./images/characters/charly.svg": 44135,
	"./images/characters/fred.png": 36981,
	"./images/characters/fred.svg": 31377,
	"./images/characters/miyu.png": 33386,
	"./images/characters/miyu.svg": 59666,
	"./images/characters/pet.png": 39287,
	"./images/characters/pet.svg": 4301,
	"./images/characters/prof.png": 68779,
	"./images/characters/prof.svg": 37983,
	"./images/characters/prof_1.png": 21639,
	"./images/characters/prof_1.svg": 7815,
	"./images/characters/prof_2.png": 70956,
	"./images/characters/prof_2.svg": 59604,
	"./images/characters/prof_3.png": 82581,
	"./images/characters/prof_3.svg": 32213,
	"./images/characters/winnie.png": 8608,
	"./images/characters/winnie.svg": 69960,
	"./images/characters/winnie2.png": 54448,
	"./images/cover_213-026.jpg": 25596,
	"./images/cover_213-850.jpg": 41459,
	"./images/cover_t034.jpg": 44860,
	"./images/dguv-icon.svg": 88545,
	"./images/dguv-icons/home.svg": 49410,
	"./images/dguv-icons/iconsLib": 95686,
	"./images/dguv-icons/iconsLib.js": 95686,
	"./images/dguv-logo.svg": 41475,
	"./images/fancy-underline.svg": 35481,
	"./images/favicon/android-chrome-192x192.png": 11309,
	"./images/favicon/android-chrome-512x512.png": 59677,
	"./images/favicon/apple-touch-icon.png": 49154,
	"./images/favicon/browserconfig.xml": 75075,
	"./images/favicon/favicon-16x16.png": 50269,
	"./images/favicon/favicon-32x32.png": 4749,
	"./images/favicon/favicon.ico": 89953,
	"./images/favicon/mstile-150x150.png": 39525,
	"./images/favicon/safari-pinned-tab.svg": 10369,
	"./images/favicon/site.webmanifest": 61950,
	"./images/icons/arrow-bottom_pink.svg": 30790,
	"./images/icons/arrow-double-top_blue.svg": 30154,
	"./images/icons/arrow-double-top_lightblue.svg": 19606,
	"./images/icons/arrow-double-top_white.svg": 69073,
	"./images/icons/arrow-left_blue.svg": 68112,
	"./images/icons/arrow-left_lightblue.svg": 53436,
	"./images/icons/arrow-left_white.svg": 75027,
	"./images/icons/arrow-right_blue.svg": 44859,
	"./images/icons/arrow-right_lightblue.svg": 21613,
	"./images/icons/arrow-right_white.svg": 16494,
	"./images/icons/arrow-top_blue.svg": 54670,
	"./images/icons/arrow-top_lightblue.svg": 71162,
	"./images/icons/arrow-top_pink.svg": 62130,
	"./images/icons/arrow-top_white.svg": 54205,
	"./images/icons/bars.svg": 83032,
	"./images/icons/bars_hover.svg": 14183,
	"./images/icons/btn-next-bg.svg": 25220,
	"./images/icons/btn-next-chapter-bg.svg": 21500,
	"./images/icons/btn-overview-bg-dark.svg": 54727,
	"./images/icons/btn-overview-bg-light.svg": 97749,
	"./images/icons/btn-overview-bg.svg": 75614,
	"./images/icons/btn-prev-chapter-bg.svg": 24444,
	"./images/icons/btn-previous-bg.svg": 30684,
	"./images/icons/btn-randomn-bg.svg": 74224,
	"./images/icons/btn-topic-bg-dark.svg": 58965,
	"./images/icons/btn-topic-bg.svg": 42184,
	"./images/icons/close_black.svg": 1806,
	"./images/icons/close_blue.svg": 62861,
	"./images/icons/close_lightblue.svg": 21287,
	"./images/icons/close_lightyellow.svg": 11427,
	"./images/icons/close_white.svg": 78388,
	"./images/icons/dguv-logo-icon.svg": 55786,
	"./images/icons/grid_blue.svg": 89409,
	"./images/icons/grid_lightblue.svg": 26539,
	"./images/icons/grid_white.svg": 39616,
	"./images/icons/home_blue.svg": 68082,
	"./images/icons/home_lightblue.svg": 73182,
	"./images/icons/info_blue.svg": 23681,
	"./images/icons/search.svg": 70830,
	"./images/icons/search_hover.svg": 21333,
	"./images/icons/search_white.svg": 37840,
	"./images/icons/share.svg": 76107,
	"./images/icons/share_hover.svg": 28508,
	"./images/icons/spinner.svg": 50545,
	"./images/labor-bg.svg": 53933,
	"./images/labor-bg_2.svg": 38738,
	"./images/labor-bg_2_gauss.svg": 13484,
	"./images/logo_dguv.png": 583,
	"./images/menu-bg.svg": 76522,
	"./images/notfound-img.svg": 75024,
	"./js/lunr.de": 90772,
	"./js/lunr.de.js": 90772,
	"./js/lunr.stemmer.support": 1913,
	"./js/lunr.stemmer.support.js": 1913,
	"./js/searchData_de": 80422,
	"./js/searchData_de.js": 80422,
	"./js/searchData_en": 24186,
	"./js/searchData_en.js": 24186,
	"./js/searchData_old": 77996,
	"./js/searchData_old.js": 77996,
	"./js/tools": 83363,
	"./js/tools.js": 83363
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17800;